import React, { useContext } from "react";
import { Grid, Typography, Box, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import YAML from "yaml";
import { WamlContext } from "../WAMLContent";
import InlineCode from "../../../../../../core/InlineCode/InlineCode";
import {makeStyles} from "@material-ui/core/styles";
import SLOProtocolCard from "./SLOProtocolCard";
import SLOCustomCard from "./SLOCustomCard";

export const SLOPageTitle = "SLOs";

const useStyles = makeStyles({
    root: {
        marginBottom: '10px'
    },
    accordionDetails: {
        flexDirection: 'column',
        padding: '16px 24px'
    },
    sectionTitle: {
        marginBottom: '16px',
        fontWeight: 'bold'
    }
})

const SLOPage = () => {
  const context = useContext(WamlContext);
  const [wapp, setWapp] = React.useState<any>(null);
  const classes = useStyles();

  React.useEffect(() => {
    if (!context.localWaml) return;
    setWapp(YAML.parse(context.localWaml));
  }, [context.localWaml]);

  if (!wapp?.deploy) {
    return <div>This <InlineCode>.weave.yaml</InlineCode> has no configured deploys.</div>;
  }

  const deployKeys = Object.keys(wapp.deploy || {});

  return (
      <Grid container spacing={3}>
          <Grid item xs={12}>
              <Typography variant="h6" className={classes.sectionTitle}>
                  Service Level Objectives (SLOs) Configuration
              </Typography>
              <Typography variant="body2" style={{ marginBottom: '20px' }}>
                  Configure availability and latency objectives for your service. SLOs are automatically converted to dashboards and alerts when deployed.
              </Typography>
          </Grid>
          
          {deployKeys.map((deployKey) => (
              <Grid item xs={12} key={deployKey}>
                  <Accordion defaultExpanded={deployKeys.length === 1}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="h6">{deployKey}</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetails}>
                          <Box mb={3}>
                              <SLOProtocolCard 
                                  protocol="http"
                                  deployKey={deployKey}
                                  wapp={wapp}
                              />
                          </Box>
                          <Box mb={3}>
                              <SLOProtocolCard 
                                  protocol="grpc"
                                  deployKey={deployKey}
                                  wapp={wapp}
                              />
                          </Box>
                          <Box>
                              <SLOCustomCard 
                                  deployKey={deployKey}
                                  wapp={wapp}
                              />
                          </Box>
                      </AccordionDetails>
                  </Accordion>
              </Grid>
          ))}
      </Grid>
  );
};

export default SLOPage;
